import Help from './Help'

export default {
  list: Help,
}
